/* ==========================================================================
   HUSSIENI HOME — V3
   Full-screen navigation with two levels, and project type tabs.
   Transform/opacity only. No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     Navigation
     The two panels live in the same overlay, so switching levels is a
     transform rather than a navigation. Back returns instantly and the
     phone's back gesture closes the menu rather than leaving the page.
     --------------------------------------------------------------------- */
  function initNav() {
    var nav = document.querySelector('[data-hh-nav]');
    if (!nav) return;

    var openers = document.querySelectorAll('[data-hh-nav-open]');
    var closers = nav.querySelectorAll('[data-hh-nav-close]');
    var panels = nav.querySelectorAll('[data-hh-panel]');
    var lastFocused = null;

    function showPanel(name) {
      panels.forEach(function (p) {
        var isTarget = p.dataset.hhPanel === name;
        p.classList.toggle('is-active', isTarget);
        // Panels we are leaving slide the opposite way, which is what makes
        // the movement read as depth rather than a cross-fade.
        p.classList.toggle('is-left', !isTarget && name !== 'root');
      });
      var active = nav.querySelector('[data-hh-panel="' + name + '"]');
      if (active) active.scrollTop = 0;
    }

    function focusables() {
      return nav.querySelectorAll(
        '.hh-nav__top button, .hh-nav__panel.is-active a[href], .hh-nav__panel.is-active button, .hh-nav__social a'
      );
    }

    function open() {
      lastFocused = document.activeElement;
      nav.hidden = false;
      showPanel('root');
      requestAnimationFrame(function () {
        nav.classList.add('is-open');
        document.body.classList.add('hh-nav-open');
        var f = focusables();
        if (f.length) f[0].focus();
      });
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      try { history.pushState({ hhNav: true }, ''); } catch (e) {}
    }

    function close(fromPop) {
      nav.classList.remove('is-open');
      document.body.classList.remove('hh-nav-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      window.setTimeout(function () { nav.hidden = true; }, reduced ? 0 : 320);
      if (lastFocused) lastFocused.focus();
      if (!fromPop) {
        try { if (history.state && history.state.hhNav) history.back(); } catch (e) {}
      }
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', function () { close(false); }); });

    nav.querySelectorAll('[data-hh-panel-to]').forEach(function (b) {
      b.addEventListener('click', function () { showPanel(b.dataset.hhPanelTo); });
    });

    window.addEventListener('popstate', function () {
      if (!nav.hidden) close(true);
    });

    document.addEventListener('keydown', function (e) {
      if (nav.hidden) return;
      if (e.key === 'Escape') {
        // Escape steps back one level before closing the whole menu.
        var sub = nav.querySelector('.hh-nav__panel.is-active:not([data-hh-panel="root"])');
        if (sub) { showPanel('root'); return; }
        close(false);
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------------------------------------------------------------------
     Project type tabs
     Filters in place rather than reloading, because the project count is
     small and a reload would throw away scroll position.
     --------------------------------------------------------------------- */
  function initProjectTabs() {
    var tabs = document.querySelectorAll('[data-hh-pjfilter]');
    if (!tabs.length) return;
    var cards = document.querySelectorAll('[data-hh-pjtype]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var want = tab.dataset.hhPjfilter;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        cards.forEach(function (card) {
          card.hidden = !(want === 'all' || card.dataset.hhPjtype === want);
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Project videos
     Supplied without audio and kept that way. They also only play while on
     screen, so an off-screen clip never burns battery.
     --------------------------------------------------------------------- */
  function initProjectVideos() {
    var vids = document.querySelectorAll('.hh-pjvid__el');
    if (!vids.length) return;

    vids.forEach(function (v) {
      // Belt and braces: the attribute is set in Liquid, but a video that
      // somehow gained a track must never make noise.
      v.muted = true;
      v.setAttribute('muted', '');
      v.volume = 0;
    });

    if (reduced || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() {
    initNav();
    initProjectTabs();
    initProjectVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
